import { render, staticRenderFns } from "./NotReadyYet.vue?vue&type=template&id=25720cfc&scoped=true&"
import script from "./NotReadyYet.vue?vue&type=script&lang=js&"
export * from "./NotReadyYet.vue?vue&type=script&lang=js&"
import style0 from "./NotReadyYet.vue?vue&type=style&index=0&id=25720cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25720cfc",
  null
  
)

export default component.exports